// ==================================================================================================
//
// Profile Purchase History Table
//
// ==================================================================================================
import m from 'moment'
import {getPurchaseHistory } from '../utilities'

const tablePurchaseHistory = () => {
  const props = {
    dateFormat: 'D-M-YYYY',
    dateRangeFormat: 'MMM D, YYYY',
    dateRangeAriaFormat: 'MMMM D, YYYY',
    startDate: m().startOf('month'),
    endDate: m().endOf('day'),
    data: [],
  };

  let els = {};

  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.wrapper = '#js-purchase-history'
    els.$dateRange = $('.js-purchase-history-date-range')
    els.$purchaseHistoryTable = $('.js-purchase-history-table-body')
    els.$purchaseTableFilter = $('#purchase-table-filter')
    els.$downloadPDFLink = $('.js-download-purchase-pdf')
  }

  // Update date range
  // ------------------------------------------------
  const updateUIDate = () => {
    const {dateRangeFormat, dateRangeAriaFormat, endDate} = props
    const status = els.$purchaseTableFilter.val()
    let days = parseInt(status.split('_')[1]);
    let date = m().subtract(days, 'days');
    const dateRangeText = date.format(dateRangeFormat) + ' - ' + endDate.format(dateRangeFormat)
    const dateRangeAria = date.format(dateRangeAriaFormat) + ' to ' + endDate.format(dateRangeAriaFormat)

    els.$dateRange.text(dateRangeText)
    els.$dateRange.siblings('.js-purchase-history-date-range-for-aria').text(dateRangeAria)
  }

  const updateDownloadLink = () =>{
    const {endDate} = props
    const status = els.$purchaseTableFilter.val()
    let days = parseInt(status.split('_')[1]);
    let date = m().subtract(days, 'days');
    const currHref = els.$downloadPDFLink.attr('href')
    const endIndex = currHref.indexOf('?') === -1 ? currHref.length : currHref.indexOf('?')
    const href = `${currHref.substring(0, endIndex)}?start=${date.format("YYYY-MM-DD")}&end=${endDate.format("YYYY-MM-DD")}`
    els.$downloadPDFLink.attr('href', href)
  }

  const updateTable = () => {
    els.$purchaseHistoryTable.empty()
    els.$purchaseHistoryTable.append($(rowTemplate(props.data)))
    els.$purchaseHistoryTable.append($(totalBalance(props.data)))
  }

  const totalBalance = total_balance => {
    const value = props.totalBalance;
    const title = props.totalTableText;
    const formattedValue = Math.abs(value);

    return total_balance = `<p class="member-profile-purchase-total-balance">${title}: ${value >=0 ? '$'+ formattedValue : '-$'+ formattedValue}</p>`
  }

  const rowTemplate = rowData => {
    return rowData.reduce((acc, cur) => {
      const value = cur.total;
      const formattedValue = Math.abs(value);
      const currencySign = cur.total >= 0 ? 'total-amount-positive' : 'total-amount-negative';
  
      return acc + `
        <div class="member-profile-purchase-chart__row" aria-label="Purchase">
          <p class="member-profile-purchase-chart__row__date type--d6 type--charcoal--80">
            <span>${m(cur.date, 'MM-DD-YY').format('MMM DD, YYYY')}</span>
          </p>
          <p class="member-profile-purchase-chart__row__service_name type--d6 type--charcoal--80">
            <span>${cur.service_name}</span>
          </p>
          <p class="member-profile-purchase-chart__row__club_id type--d6 type--charcoal--80">
            <span>${cur.club_id}</span>
          </p>
          <p class="member-profile-purchase-chart__row__total type--d6 type--charcoal--80 ${currencySign}">
            <span>${value >=0 ? '$'+ formattedValue : '-$'+ formattedValue}</span>
          </p>
        </div>
      `;
    }, '');
  };
  

  // Show table & remove error message
  // ------------------------------------------------
  const removeError = () => {
    if ($(els.wrapper).hasClass('was-removed')) {
      $('.member-profile-purchase-history-message').fadeOut(500, () => {
        $('.member-profile-purchase-history-message').remove()
        $(els.wrapper).removeClass('was-removed')
        $(els.wrapper).parents('.member-profile-purchase-history-wrapper__interior').fadeIn(500)

        if ($(els.wrapper).hasClass('all-removed')) {
          $('.js-purchase-history-table').slideDown(500)
          $(els.wrapper).removeClass('all-removed')
        }
      })
    }
  }

  // Hide table & show error message
  // ------------------------------------------------
  const showError = (hideAll, errorMessage) => {
    if (hideAll) {
      $('.js-purchase-history-table').slideUp(500)
      $(els.wrapper).addClass('all-removed')
    }

    $(els.wrapper).parents('.member-profile-purchase-history-wrapper__interior').slideUp(500, () => {
      // append 'narrow search' message & clear the datepicker
      $(els.wrapper).parents('.member-profile-purchase-history-wrapper').append(errorMessage).hide().delay(30).slideDown(500)
    })

    // add class to denote the graph was removed
    // and don't update the date range
    $(els.wrapper).addClass('was-removed')
  }

  // Get purchase history data from server
  // ------------------------------------------------
  const getPurchaseHistoryData = () => {

    const memberId = els.$purchaseHistoryTable.data('member-id')
    const status = els.$purchaseTableFilter.val()
    let date = new Date();
    let days = parseInt(status.split('_')[1]);
    date.setDate(date.getDate() - days);
    getPurchaseHistory({
      memberId,
      startDate: date.toISOString().slice(0, 10),
      endDate: props.endDate.format('YYYY-MM-DD'),
      onSuccess: data => onpurchaseHistorySuccess(JSON.parse(data)),
      onError: () => onpurchaseHistoryError()
    })
  }

  const hide_chart = () =>{
    var chart = document.querySelector('.js-purchase-chart-table');
    $(chart).fadeOut(500);
    els.$downloadPDFLink.fadeOut(500);
  }

  const display_chart = () =>{
    var chart = document.querySelector('.js-purchase-chart-table');
    $(chart).fadeIn(500);
    els.$downloadPDFLink.fadeIn(500);
  }

  const onpurchaseHistorySuccess = (data) => {
    props.totalBalance = data.total_balance;
    props.totalTableText = data.total_table_text;
    props.data = data.invoices.map(el => {
      return Object.assign(el, {
        date: el.purchase_date,
        service_name: el.service_name,
        club_id: el.mms_club_id,
        total: el.amount,
      })
    })
    if (props.data.length > 0) {
      removeError()
      display_chart();
      updateTable()
    } else {
      hide_chart();
      const $noDataExistsMessage = $('<div class="member-profile-purchase-history-message member-profile-purchase-history-message--no-data"><p class="type--center type--d6 type--charcoal-50" aria-role="alert">There were no purchases in the selected date range. Please select another range.</p></div>')

      if ($('.member-profile-purchase-history-message').length > 0) {
        $('.member-profile-purchase-history-message').fadeOut(500, () => {
          $('.member-profile-purchase-history-message').remove();
          showError(true, $noDataExistsMessage)
        })
      } else {
        showError(true, $noDataExistsMessage)
      }
    }
  }

  const onpurchaseHistoryError = () => {
    const $fetchingHistoryFailedMessage = $('<div class="member-profile-purchase-history-message member-profile-purchase-history-message--fetching-failed"><p class="type--center type--d6 type--charcoal-50" aria-role="alert">Something went wrong while fetching purchase history. Please try again later.</p></div>')
    hide_chart();
    if ($('.member-profile-purchase-history-message').length > 0) {
      $('.member-profile-purchase-history-message').fadeOut(500, () => {
        $('.member-profile-purchase-history-message').remove()
        showError(true, $fetchingHistoryFailedMessage)
      })
    } else {
      showError(true, $fetchingHistoryFailedMessage)
    }
  }



  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // Add your event handlers here
    updateUIDate()
    updateDownloadLink();
    els.$purchaseTableFilter.on('change', getPurchaseHistoryData)
    els.$purchaseTableFilter.on('change', updateUIDate)
    els.$purchaseTableFilter.on('change', updateDownloadLink)
    props.isEnabled = true;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here
    props.isEnabled = false;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren();
    enable();
    getPurchaseHistoryData();
  }

  return {
    init,
    enable,
    disable
  };
}

export default tablePurchaseHistory;
